var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCourthouse(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M17.42 1.37996C17.21 1.23996 16.95 1.20994 16.72 1.29994C15.29 1.86994 13.71 1.86994 12.28 1.29994C12.05 1.20994 11.79 1.23996 11.58 1.37996C11.37 1.51996 11.25 1.74995 11.25 1.99995V4.99995V7.99995C11.25 8.40995 11.59 8.74995 12 8.74995C12.41 8.74995 12.75 8.40995 12.75 7.99995V6.01997C13.33 6.15997 13.91 6.23994 14.5 6.23994C15.44 6.23994 16.38 6.05996 17.28 5.69996C17.56 5.58996 17.75 5.30995 17.75 4.99995V1.99995C17.75 1.74995 17.63 1.51996 17.42 1.37996Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 21.25H20.75V11C20.75 8.58 19.42 7.25 17 7.25H7C4.58 7.25 3.25 8.58 3.25 11V21.25H2C1.59 21.25 1.25 21.59 1.25 22C1.25 22.41 1.59 22.75 2 22.75H4H20H22C22.41 22.75 22.75 22.41 22.75 22C22.75 21.59 22.41 21.25 22 21.25ZM19.25 12.75V21.25H16.74V12.75H19.25ZM11.24 21.25H8.74V12.75H11.24V21.25ZM12.74 12.75H15.24V21.25H12.74V12.75ZM4.75 12.75H7.24V21.25H4.75V12.75Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCourthouse);
export default __webpack_public_path__ + "static/media/courthouse.be24343bea8317a0d142961f497b3880.svg";
export { ForwardRef as ReactComponent };